export default __webpack_public_path__ + "static/workstation-8e4fd1b05db159edd5ab8f2aa68699b0.jpg";